/**
 * Queue Agent class
 */
import { DurationToSec } from './helper'

export default class QueueAgent {
  constructor (data) {
    Object.keys(data).forEach(key => {
      switch (key) {
        case 'subscriber_id':
          this.subscriberId = data.subscriber_id
          break
        case 'oncall':
          // skip, will be returned from getter
          break
        default:
          this[key] = data[key]
          break
      }
    })
    this.ringing = false
    this.penalty = 0
    this.lastcall = 0
    this.calls = []
    this.status = 0
  }

  /**
   * @getter
   * Agent is on call when has calls
   * @return Boolean
   */
  get oncall () {
    return this.calls.length > 0
  }

  /**
   * @public
   * Add new call to agent calls list
   * @param Object AMI event object
   * @return void
   */
  addCall (evt) {
    const channel = evt.channel
    if (this.hasCallWithChan(channel)) {
      return
    }
    const call = {
      callerName: evt.calleridname,
      callerNum: evt.calleridnum,
      holdtime: ~~evt.holdtime,
      ringtime: ~~evt.ringtime,
      wait: ~~evt.wait,
      position: ~~evt.position,
      channel: channel,
      utime: Date.now() - (DurationToSec(evt.duration) * 1000)
    }
    this.calls.push(call)
  }

  /**
   * @public
   * Check if agent has call with channel
   *
   * @param channel String call channel
   * @return Boolean
   */
  hasCallWithChan (channel) {
    return this.calls.filter(call => call.channel === channel).length > 0
  }

  /**
   * @public
   * Add new call to agent calls list
   * @param Object AMI event object
   * @return void
   */
  delCall (channel) {
    const callIdx = this.calls.findIndex((c) => c.channel === channel)
    if (callIdx !== -1) {
      this.calls.splice(callIdx, 1)
    }
  }
}
